<template>
  <img v-if="imageSource" v-bind:src="`data:imagejpeg;base64,${this.imageSource}`" :alt="altText">
  <v-icon v-else>fas fa-user</v-icon>
</template>


<script lang="js">
import moment from 'moment';

import appSettings from '../appSettings';

export default {
  name: 'ClientImage',
  data() {
    return {
      imageSource: null,
    };
  },
  props: {
    clientID: String,
    clientName: Object
  },
  components: {
  },
  created() {
    this.setClientImage();
    this.$eventbus.$on('clientImageUpdated', async (clientID) => {
      if (clientID === this.clientID) {
        this.setClientImage();
      }
    });
  },
  computed: {
    altText() {
      let returnValue = null;

      if (this.clientName) {
        returnValue = `${this.clientName.first} ${this.clientName.last}`;
      } else {
        returnValue = 'Client Image';
      }

      return returnValue;
    }
  },
  methods: {
    setClientImage() {
      this.$store
        .dispatch('getClientImage', this.clientID)
        .then((clientImage) => {
          if (clientImage && clientImage.selectedClientImage) {
            this.imageSource = clientImage.selectedClientImage.encodedImage;
          }
        })
        .catch((err) => {
          this.$log.error(`[${moment().format(appSettings.logDateFormat)}] ClientImage.setClientImage: '${err.message}' `);
        });
    }
  }
};
</script>


<style lang="scss">
</style>
